import { useAuthStore } from '@/stores/auth';

export default defineNuxtPlugin(async (nuxtApp) => {
  const config = useRuntimeConfig();
  const authStore = useAuthStore();

  authStore.loadToken(); // Token aus localStorage laden

  if (!authStore.token) {
    const username = config.public.API_USER
    const password = 'G0rkan002!'

    try {
        await authStore.fetchToken(username, password);
    } catch (error) {
        console.error(error)
    }
  }

  nuxtApp.provide('token', authStore.token);
});
